import { Dimensions, Platform, StyleSheet } from 'react-native'
import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: theme => ({
    backgroundColor:
      theme.name === 'light' ? theme.colors.backgroundColor : null,
  }),
  scrollContainer: withTray => ({
    marginHorizontal: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 0 : 16,
    paddingBottom: withTray ? 100 : null,
    flexGrow: 1,
    justifyContent: 'space-between',
  }),
  headerText: {
    ...Fonts.type.bold,
    fontSize: 25,
    lineHeight: 31.2,
    marginTop: 25,
  },
  priceValue: {
    fontSize: 24,
    fontFamily: Fonts.type.VFFont,
  },
  unitValue: {
    fontSize: 18,
    fontFamily: Fonts.type.VFFont,
  },
  durationText: {
    fontSize: 18.7,
    lineHeight: 25,
  },
  descriptionText: {
    fontSize: 16.6,
    lineHeight: 25,
    marginTop: 16.6,
  },
  mainButton: {
    marginTop: 16.1,
    marginBottom: 38.2,
  },
  textStyle: {
    fontSize: 18.7,
  },
  priceContainer: {
    marginVertical: 16.6,
  },
  recordText: {
    fontSize: 16.6,
    lineHeight: 22.9,
  },
  description: {
    marginBottom: 32,
  },
})
